import { render, staticRenderFns } from "./CreateContractASoRDialog.vue?vue&type=template&id=2588b398"
import script from "./CreateContractASoRDialog.vue?vue&type=script&lang=js"
export * from "./CreateContractASoRDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateContractASoRDialog.vue?vue&type=style&index=0&id=2588b398&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports